


angular.module('admin.dialogs', [])
.controller('SubmitCancelDialogCtrl',function($rootScope, $uibModalInstance, params, $q, dialogs, $timeout, $translate){
		//-- Variables --//

		var self = this;
		self.data = params.data;
		self.params = {
			submit: function(){return $q.resolve(true);},
			cancel: function(){return $q.resolve(true);},
			failure: function(error){return $q.reject(error);},
		}
		angular.extend(self.params, params);
		self.message = null;
		self.is_busy = false;

		//-- Methods --//
		
		self.failure = function(error){
			self.message={type:'danger', body:error.data.message || 'An error has occured'}
			if (error.data.code == 401) {
				$rootScope.$emit('unauthorized');
			}
			if (error.data.code == 1) {
				self.message.type='warning';
			}
		}
		
		self.cancel = function(){
			return self.params.cancel(self.data).then(function(){
				$uibModalInstance.dismiss('Canceled');
			}).catch(self.failure);
		}; // end cancel
		
		self.submit = function(){
			if (self.is_busy) {
				return;
			}
			self.is_busy = true;
			return self.params.submit(self.data).then(function(result){
				$uibModalInstance.close(result);
				if (result && result.__callstatus && result.__callstatus.message) {
					$timeout(function(){
						var title = self.params.title? $translate.instant(self.params.title) : $translate.instant('Information');
						dialogs.notify(title, $translate.instant(result.__callstatus.message));
					}, 500);  // wait for the prevoius dialog to hide
				}
				//self.is_busy = false;
			}).catch(function(error){
				self.is_busy = false;
				self.params.failure(error).then(self.failure).catch(self.failure);
			});
		};  // end save
		
		self.hitEnter = function(evt, is_true){
			if(angular.equals(evt.keyCode,13) && is_true)
				self.submit();
		};
}) // end controller(customDialogCtrl)



